import React from 'react';
import { Search, Plus } from 'lucide-react';
import { SectionMiniHeader, DataGrid, PaginationControls } from './';


const EMPTY_ARRAY = [];

/**
 * ModuleDataView - Generic Container for DataGrid with Header and Animations.
 * Standardizes the "Main Content" area of all modules.
 */
const ModuleDataView = (props) => {
    const {
        icon,
        title,
        subtitle,
        count,
        filtersVisible,
        onToggleFilters,
        actions,
        columns,
        data,
        loading = false,
        emptyTitle = "No Results",
        emptyDescription = "No records match the current criteria.",
        emptyIcon = Search,
        selectable = false,
        selectedIds = EMPTY_ARRAY,
        onSelectAll,
        onSelectRow,
        getIndicatorColor,
        isTerminal = false,
        children,
        ...paginationProps
    } = props;

    const {
        onNextPage,
        onPrevPage,
        onPageSizeChange,
        pageSize,
        currentPage,
        totalPages,
        hasMore,
        hasPrev,
        totalCount,
        selectedCount
    } = paginationProps;

    return (
        <main className="flex-1 min-h-0 min-w-0 w-full flex flex-col gap-0 animate-in fade-in slide-in-from-right-4 duration-700">
            <SectionMiniHeader
                icon={icon}
                title={title}
                subtitle={subtitle}
                count={count || totalCount}
                filtersVisible={filtersVisible}
                onToggleFilters={onToggleFilters}
                isTerminal={isTerminal}
            >
                {actions}
            </SectionMiniHeader>
            <div className="flex-1 relative z-10 overflow-hidden flex flex-col min-h-0">
                <div className="flex-1 flex overflow-hidden">
                    {children || (
                        <DataGrid
                            {...props}
                            columns={columns}
                            data={data}
                            loading={loading}
                            selectable={selectable}
                            selectedIds={selectedIds}
                            onSelectAll={onSelectAll}
                            onSelectRow={onSelectRow}
                            getIndicatorColor={getIndicatorColor}
                        />
                    )}
                </div>

                {/* Unified Pagination Footer - Desktop only, mobile uses infinite scroll */}
                <div className="hidden md:flex w-full shrink-0 bg-white/60 backdrop-blur-md border-t border-slate-100 pt-3 pb-0 mt-auto">
                    <PaginationControls 
                        totalCount={totalCount}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        pageSize={pageSize}
                        onNextPage={onNextPage}
                        onPrevPage={onPrevPage}
                        onPageSizeChange={onPageSizeChange}
                        hasMore={hasMore}
                        hasPrev={hasPrev}
                        selectedCount={selectedCount}
                    />
                </div>
            </div>
        </main>
    );
};

export default ModuleDataView;
